export const ArrowIcon = ({ className }) => {
  return (
    <svg
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="back-arrow"
    >
      <path
        d="M1 7L3.5 4L1 1"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HomeIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="7"
        height="7"
        rx="1"
        stroke="#54565A"
        strokeWidth="2"
      />
      <rect
        x="12"
        y="1"
        width="7"
        height="7"
        rx="1"
        stroke="#54565A"
        strokeWidth="2"
      />
      <rect
        x="12"
        y="12"
        width="7"
        height="7"
        rx="1"
        stroke="#54565A"
        strokeWidth="2"
      />
      <rect
        x="1"
        y="12"
        width="7"
        height="7"
        rx="1"
        stroke="#54565A"
        strokeWidth="2"
      />
    </svg>
  );
};

export const ChartIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="chart-icon"
    >
      <path
        d="M15.7141 13.5714H17.1426V17.1429H15.7141V13.5714ZM12.8569 10H14.2855V17.1429H12.8569V10ZM6.42836 17.1429C5.48151 17.1417 4.57376 16.7651 3.90423 16.0956C3.23471 15.426 2.85807 14.5183 2.85693 13.5714H4.28551C4.28551 13.9952 4.41118 14.4095 4.64664 14.7619C4.8821 15.1143 5.21677 15.389 5.60833 15.5512C5.99988 15.7134 6.43074 15.7558 6.84641 15.6731C7.26209 15.5904 7.64391 15.3863 7.94359 15.0867C8.24328 14.787 8.44736 14.4052 8.53005 13.9895C8.61273 13.5738 8.57029 13.1429 8.4081 12.7514C8.24592 12.3598 7.97126 12.0252 7.61887 11.7897C7.26648 11.5542 6.85218 11.4286 6.42836 11.4286V10C7.37556 10 8.28397 10.3763 8.95374 11.046C9.62352 11.7158 9.99979 12.6242 9.99979 13.5714C9.99979 14.5186 9.62352 15.427 8.95374 16.0968C8.28397 16.7666 7.37556 17.1429 6.42836 17.1429Z"
        fill="#54565A"
      />
      <path
        d="M18.5714 0H1.42857C1.04981 0.000378198 0.686664 0.151009 0.418837 0.418837C0.151009 0.686664 0.000378198 1.04981 0 1.42857V18.5714C0.000378198 18.9502 0.151009 19.3133 0.418837 19.5812C0.686664 19.849 1.04981 19.9996 1.42857 20H18.5714C18.9501 19.9994 19.3132 19.8487 19.581 19.581C19.8487 19.3132 19.9994 18.9501 20 18.5714V1.42857C19.9996 1.04981 19.849 0.686664 19.5812 0.418837C19.3133 0.151009 18.9502 0.000378198 18.5714 0ZM18.5714 6.42857H8.57143V1.42857H18.5714V6.42857ZM7.14286 1.42857V6.42857H1.42857V1.42857H7.14286ZM1.42857 18.5714V7.85714H18.5714L18.5729 18.5714H1.42857Z"
        fill="#54565A"
      />
    </svg>
  );
};

export const GraphIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="graph-icon"
    >
      <path
        d="M17.9994 10.1367H9.86331V2.00062C9.86331 1.90062 9.7815 1.81881 9.6815 1.81881H9.09061C7.89679 1.81685 6.71436 2.05097 5.61135 2.5077C4.50835 2.96442 3.50654 3.63474 2.66356 4.48008C1.83338 5.30769 1.17191 6.28871 0.715898 7.36861C0.241381 8.48866 -0.00211181 9.69298 1.37976e-05 10.9094C-0.0019411 12.1032 0.232179 13.2856 0.688904 14.3887C1.14563 15.4917 1.81594 16.4935 2.66129 17.3364C3.49535 18.1705 4.46804 18.8273 5.54982 19.2841C6.66987 19.7586 7.87419 20.0021 9.09061 20C10.2844 20.0019 11.4669 19.7678 12.5699 19.3111C13.6729 18.8544 14.6747 18.1841 15.5177 17.3387C16.3517 16.5047 17.0085 15.532 17.4653 14.4502C17.9398 13.3301 18.1833 12.1258 18.1812 10.9094V10.3185C18.1812 10.2185 18.0994 10.1367 17.9994 10.1367ZM14.4018 16.2683C13.6981 16.9665 12.8635 17.5191 11.9458 17.8942C11.0282 18.2694 10.0456 18.4598 9.05425 18.4546C7.05204 18.4455 5.17029 17.6614 3.75443 16.2456C2.32948 14.8206 1.54542 12.9252 1.54542 10.9094C1.54542 8.89356 2.32948 6.99817 3.75443 5.57322C4.9953 4.33236 6.59297 3.57556 8.31791 3.40284V11.6821H16.5972C16.4222 13.4161 15.6586 15.0229 14.4018 16.2683V16.2683ZM19.9993 8.8731L19.9402 8.23222C19.7471 6.13911 18.8175 4.16418 17.3221 2.67332C15.8257 1.17973 13.8548 0.255375 11.7496 0.0597791L11.1065 0.000690265C10.9996 -0.00840032 10.9087 0.073415 10.9087 0.180229V8.90947C10.9087 9.00946 10.9905 9.09128 11.0905 9.09128L19.8175 9.06855C19.9243 9.06855 20.0084 8.97765 19.9993 8.8731ZM12.4496 7.55042V1.71881C13.8812 2.01845 15.195 2.72745 16.2313 3.75965C17.2699 4.79598 17.9812 6.11411 18.2767 7.53452L12.4496 7.55042Z"
        fill="#54565A"
      />
    </svg>
  );
};

export const UserManageIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="user-manage-icon"
    >
      <path
        d="M8.69707 12.093V13.9535C6.96712 13.9535 5.30802 14.5415 4.08475 15.5882C2.86149 16.635 2.17427 18.0546 2.17427 19.5349H0C0 17.5612 0.916296 15.6683 2.54731 14.2727C4.17833 12.8771 6.39046 12.093 8.69707 12.093V12.093ZM8.69707 11.1628C5.09322 11.1628 2.17427 8.66512 2.17427 5.5814C2.17427 2.49767 5.09322 0 8.69707 0C12.3009 0 15.2199 2.49767 15.2199 5.5814C15.2199 8.66512 12.3009 11.1628 8.69707 11.1628ZM8.69707 9.30233C11.0996 9.30233 13.0456 7.63721 13.0456 5.5814C13.0456 3.52558 11.0996 1.86047 8.69707 1.86047C6.2945 1.86047 4.34854 3.52558 4.34854 5.5814C4.34854 7.63721 6.2945 9.30233 8.69707 9.30233ZM11.5182 16.5693C11.3803 16.073 11.3803 15.5559 11.5182 15.0595L10.4397 14.5265L11.5269 12.9153L12.6053 13.4484C13.0382 13.0976 13.5614 12.8388 14.1327 12.693V11.6279H16.307V12.693C16.8854 12.84 17.4072 13.1023 17.8344 13.4484L18.9129 12.9153L20 14.5265L18.9216 15.0595C19.0592 15.5556 19.0592 16.0723 18.9216 16.5684L20 17.1014L18.9129 18.7126L17.8344 18.1795C17.4016 18.5303 16.8783 18.7891 16.307 18.9349V20H14.1327V18.9349C13.5614 18.7891 13.0382 18.5303 12.6053 18.1795L11.5269 18.7126L10.4397 17.1014L11.5182 16.5693V16.5693ZM15.2199 17.2093C15.6524 17.2093 16.0671 17.0623 16.373 16.8006C16.6788 16.5389 16.8506 16.184 16.8506 15.814C16.8506 15.4439 16.6788 15.089 16.373 14.8273C16.0671 14.5656 15.6524 14.4186 15.2199 14.4186C14.7874 14.4186 14.3726 14.5656 14.0668 14.8273C13.761 15.089 13.5892 15.4439 13.5892 15.814C13.5892 16.184 13.761 16.5389 14.0668 16.8006C14.3726 17.0623 14.7874 17.2093 15.2199 17.2093Z"
        fill="#54565A"
      />
    </svg>
  );
};

export const ViewIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.44444 10.4118L8.77778 6.88235L12.1111 10.4118L16.5556 5.70588M6.55556 21L11 16.2941L15.4444 21M1 1H21M2.11111 1H19.8889V15.1176C19.8889 15.4297 19.7718 15.7289 19.5635 15.9495C19.3551 16.1702 19.0725 16.2941 18.7778 16.2941H3.22222C2.92754 16.2941 2.64492 16.1702 2.43655 15.9495C2.22817 15.7289 2.11111 15.4297 2.11111 15.1176V1Z"
        stroke="#54565A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DepartmentIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="department-icon"
    >
      <path
        d="M18.6667 5.71123H15.3333V7.13904H18.6667V11.4225H14V12.8503H16V14.3794C15.3716 14.5532 14.8239 14.9664 14.4596 15.5417C14.0953 16.1169 13.9395 16.8147 14.0213 17.5042C14.103 18.1937 14.4168 18.8276 14.9038 19.2871C15.3908 19.7465 16.0176 20 16.6667 20C17.3157 20 17.9425 19.7465 18.4295 19.2871C18.9165 18.8276 19.2303 18.1937 19.3121 17.5042C19.3939 16.8147 19.238 16.1169 18.8737 15.5417C18.5095 14.9664 17.9618 14.5532 17.3333 14.3794V12.8503H18.6667C19.0201 12.8497 19.359 12.6991 19.6089 12.4314C19.8588 12.1638 19.9995 11.801 20 11.4225V7.13904C19.9996 6.76047 19.8591 6.39753 19.6091 6.12984C19.3591 5.86216 19.0202 5.71161 18.6667 5.71123ZM18 17.1337C18 17.4161 17.9218 17.6921 17.7753 17.9269C17.6288 18.1617 17.4205 18.3447 17.1769 18.4528C16.9333 18.5609 16.6652 18.5892 16.4065 18.5341C16.1479 18.479 15.9103 18.343 15.7239 18.1433C15.5374 17.9436 15.4104 17.6892 15.359 17.4122C15.3075 17.1353 15.3339 16.8482 15.4348 16.5873C15.5357 16.3264 15.7066 16.1034 15.9259 15.9465C16.1452 15.7896 16.403 15.7059 16.6667 15.7059C17.0201 15.7064 17.359 15.8571 17.6089 16.1247C17.8588 16.3923 17.9995 16.7552 18 17.1337V17.1337ZM12 2.85561H8.66667V4.28342H12V8.56684H7.33333V9.99465H9.33333V14.3794C8.70489 14.5532 8.15721 14.9664 7.79293 15.5417C7.42866 16.1169 7.2728 16.8147 7.35459 17.5042C7.43637 18.1937 7.75017 18.8276 8.23718 19.2871C8.72418 19.7465 9.35095 20 10 20C10.649 20 11.2758 19.7465 11.7628 19.2871C12.2498 18.8276 12.5636 18.1937 12.6454 17.5042C12.7272 16.8147 12.5713 16.1169 12.2071 15.5417C11.8428 14.9664 11.2951 14.5532 10.6667 14.3794V9.99465H12C12.3535 9.99427 12.6924 9.84372 12.9424 9.57604C13.1924 9.30835 13.333 8.94541 13.3333 8.56684V4.28342C13.333 3.90486 13.1924 3.54191 12.9424 3.27423C12.6924 3.00654 12.3535 2.85599 12 2.85561V2.85561ZM11.3333 17.1337C11.3333 17.4161 11.2551 17.6921 11.1086 17.9269C10.9621 18.1617 10.7539 18.3447 10.5102 18.4528C10.2666 18.5609 9.99852 18.5892 9.73988 18.5341C9.48124 18.479 9.24366 18.343 9.05719 18.1433C8.87072 17.9436 8.74373 17.6892 8.69229 17.4122C8.64084 17.1353 8.66724 16.8482 8.76816 16.5873C8.86908 16.3264 9.03997 16.1034 9.25924 15.9465C9.47851 15.7896 9.73629 15.7059 10 15.7059C10.3535 15.7064 10.6923 15.8571 10.9422 16.1247C11.1922 16.3923 11.3328 16.7552 11.3333 17.1337ZM5.33333 0H1.33333C0.97982 0.000377995 0.640886 0.150929 0.390914 0.418613C0.140942 0.686296 0.000352984 1.04925 0 1.42781V5.71123C0.000352984 6.08979 0.140942 6.45274 0.390914 6.72042C0.640886 6.98811 0.97982 7.13866 1.33333 7.13904H2.66667V14.3794C2.03823 14.5532 1.49054 14.9664 1.12627 15.5417C0.761991 16.1169 0.606138 16.8147 0.687921 17.5042C0.769704 18.1937 1.08351 18.8276 1.57051 19.2871C2.05752 19.7465 2.68428 20 3.33333 20C3.98238 20 4.60915 19.7465 5.09616 19.2871C5.58316 18.8276 5.89696 18.1937 5.97875 17.5042C6.06053 16.8147 5.90468 16.1169 5.5404 15.5417C5.17613 14.9664 4.62844 14.5532 4 14.3794V7.13904H5.33333C5.68685 7.13866 6.02578 6.98811 6.27575 6.72042C6.52572 6.45274 6.66631 6.08979 6.66667 5.71123V1.42781C6.66631 1.04925 6.52572 0.686296 6.27575 0.418613C6.02578 0.150929 5.68685 0.000377995 5.33333 0V0ZM4.66667 17.1337C4.66667 17.4161 4.58847 17.6921 4.44196 17.9269C4.29545 18.1617 4.08721 18.3447 3.84358 18.4528C3.59994 18.5609 3.33185 18.5892 3.07321 18.5341C2.81457 18.479 2.57699 18.343 2.39052 18.1433C2.20405 17.9436 2.07707 17.6892 2.02562 17.4122C1.97417 17.1353 2.00058 16.8482 2.10149 16.5873C2.20241 16.3264 2.37331 16.1034 2.59257 15.9465C2.81184 15.7896 3.06963 15.7059 3.33333 15.7059C3.68685 15.7063 4.02578 15.8568 4.27575 16.1245C4.52572 16.3922 4.66631 16.7551 4.66667 17.1337ZM1.33333 5.71123V1.42781H5.33333L5.33467 5.71123H1.33333Z"
        fill="#54565A"
      />
    </svg>
  );
};

export const SettingsIcon = ({ className }) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4992 11.9702L16.5057 11.9743L16.5124 11.9781L17.4935 12.5505C17.9262 12.8493 18.1259 13.4687 17.8443 14.1189L17.0296 15.5038L17.0256 15.5107L17.0217 15.5177C16.7754 15.961 16.1784 16.1618 15.6743 15.8593L15.6743 15.8593L15.6674 15.8552L14.6735 15.2754C13.1403 14.3392 11.1899 15.5153 11.1899 17.25V18.3333C11.1899 18.891 10.7309 19.35 10.1732 19.35H8.50654C7.94886 19.35 7.48988 18.891 7.48988 18.3333V17.1667C7.48988 15.4393 5.55586 14.2657 4.02561 15.1804L3.04919 15.6686L3.01299 15.6867L2.97932 15.7092C2.56936 15.9825 1.97739 15.8802 1.64854 15.3344L0.816801 13.9204L0.807525 13.9047L0.797376 13.8894C0.524225 13.4797 0.626257 12.8882 1.17122 12.5592L2.15863 11.9832C3.68363 11.1515 3.68363 8.84852 2.15863 8.01676L1.1862 7.44952C0.738411 7.14054 0.56683 6.52058 0.829157 5.97522L1.65013 4.57956L1.65419 4.57266L1.65808 4.56567C1.90437 4.12234 2.50132 3.92156 3.00546 4.22404L3.02686 4.23688L3.04919 4.24804L4.02561 4.73626C5.55586 5.65093 7.48988 4.47741 7.48988 2.75V1.66667C7.48988 1.10899 7.94886 0.65 8.50654 0.65H10.1732C10.7309 0.65 11.1899 1.10899 11.1899 1.66667V2.83333C11.1899 4.56804 13.1403 5.74416 14.6735 4.80789L15.6674 4.22812L15.6842 4.21831L15.7004 4.2075C16.1104 3.93421 16.7023 4.03649 17.0312 4.58219C17.0316 4.58293 17.0321 4.58368 17.0325 4.58442L17.863 5.99623L17.8722 6.012L17.8824 6.02722C18.1555 6.43695 18.0535 7.02847 17.5085 7.35743L16.5124 7.93854L16.5057 7.9424L16.4992 7.94642C15.0034 8.8669 15.0034 11.0498 16.4992 11.9702ZM5.35654 10C5.35654 12.1923 7.14756 13.9833 9.33988 13.9833C11.5322 13.9833 13.3232 12.1923 13.3232 10C13.3232 7.80768 11.5322 6.01667 9.33988 6.01667C7.14756 6.01667 5.35654 7.80768 5.35654 10Z"
        stroke="#54565A"
        strokeWidth="1.3"
      />
    </svg>
  );
};

export const ResetIcon = ({ className }) => {
  return (
    <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
      <path d="M115,25.21a64,64,0,0,0-13-12.82,2,2,0,1,0-2.36,3.22,60.13,60.13,0,0,1,.86,96.11A59.79,59.79,0,0,1,16.6,100.36a60.17,60.17,0,0,1,8.33-81.62V38a2,2,0,1,0,4,0V14a2,2,0,0,0-2-2H2a2,2,0,0,0,0,4H22A64,64,0,0,0,64.27,128a63.39,63.39,0,0,0,38.61-13.07A64.18,64.18,0,0,0,115,25.21Z" />
      <path d="M63.83,67a2,2,0,0,0,2-2V2a2,2,0,1,0-4,0V65A2,2,0,0,0,63.83,67Z" />
    </svg>
  );
};
